import axios from 'axios';
import VueCookies from 'vue-cookies'
import { Toast } from 'vant';

// export const URLscheme = 'https://'
// // export const url = '10.0.0.121:9999'
// export const url = 'sfadmin.ysk360.com'

// export const webSocketprefix = "wss://"







export const URLscheme = 'http://'
//export const url = 'service.ysk360.com'
export const url = window.g.ApiUrl
export const webSocketprefix = "ws://"




export const service = axios.create({
  baseURL: `${url}`, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
})


service.interceptors.request.use(
  config => {
    // do something before request is sent
    console.log(VueCookies.get('token'));

      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['whartToken'] = VueCookies.get('token')

    return config
  },
  error => {
    // do something with request error
    Toast.fail("服务器异常");
    console.log(error) // for debug
    return Promise.reject(error)
  }
)





// WEBPACK FOOTER //
// ./src/axios/axios.js